import { render, staticRenderFns } from "./FeaturesTab.vue?vue&type=template&id=1259a44a&scoped=true&"
import script from "./FeaturesTab.vue?vue&type=script&lang=js&"
export * from "./FeaturesTab.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesTab.vue?vue&type=style&index=0&id=1259a44a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1259a44a",
  null
  
)

export default component.exports
import {QCheckbox,QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCheckbox,QToggle})
